import { render } from "./OltDetails.vue?vue&type=template&id=2a864b0e&scoped=true"
import script from "./OltDetails.vue?vue&type=script&lang=js"
export * from "./OltDetails.vue?vue&type=script&lang=js"

import "./OltDetails.vue?vue&type=style&index=0&id=2a864b0e&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a864b0e"]])

export default __exports__